import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles<Theme>(theme => ({
    modal: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 0,
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
        borderRadius: '20px',
        border: '0',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            width: '95%',
        },
        [theme.breakpoints.between(MOBILE_BREAKPOINT, 'md')]: {
            width: '85%',
        },
        [theme.breakpoints.between('md', 'lg')]: {
            width: '75%',
        },
        [theme.breakpoints.between('lg', 'xl')]: {
            width: '65%',
        },
        [theme.breakpoints.up('xl')]: {
            width: '55%',
        },
    },
    logo: {
        height: '50px',
        marginBottom: '22px',
    },
    largeText: {
        fontSize: '23px',
        fontWeight: 400,
        marginBottom: '8px',
    },
    checkSpamText: {
        fontSize: '14px',
        marginTop: '28px',
    },
    mailLink: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
    },
}));
